import * as actionTypes from "../actions/actionTypes";

const initialState = {};

const getTopicsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TOPICS_LIST:
      return {
        topics: action.payload.topics,
      };

    default:
      return state;
  }
};
export default getTopicsReducer;
